import { render, staticRenderFns } from "./ExtractionSchemePsSettle.vue?vue&type=template&id=2b858cd6&scoped=true"
import script from "./ExtractionSchemePsSettle.vue?vue&type=script&lang=js"
export * from "./ExtractionSchemePsSettle.vue?vue&type=script&lang=js"
import style0 from "./ExtractionSchemePsSettle.vue?vue&type=style&index=0&id=2b858cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b858cd6",
  null
  
)

export default component.exports